import React, { useEffect, useRef } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf.mjs";

GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

const MAX_SCALE = 2.5;

// Draws a PDF onto canvases. The site's security policy blocks PDFs in iframes, and phones
// often cannot show them inline at all.
export default function PdfPages({ blob, title, onError }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!blob || !container) return undefined;
    let active = true;
    let pdf = null;

    (async () => {
      const data = new Uint8Array(await blob.arrayBuffer());
      pdf = await getDocument({ data, useWorkerFetch: false, isEvalSupported: false }).promise;
      for (let pageNumber = 1; pageNumber <= pdf.numPages && active; pageNumber += 1) {
        const page = await pdf.getPage(pageNumber);
        const width = page.getViewport({ scale: 1 }).width;
        const scale = Math.min(MAX_SCALE, (container.clientWidth * (window.devicePixelRatio || 1)) / width);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(viewport.width);
        canvas.height = Math.round(viewport.height);
        await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
        if (active) container.appendChild(canvas);
      }
    })().catch(() => {
      if (active && onError) onError();
    });

    return () => {
      active = false;
      container.replaceChildren();
      if (pdf) pdf.destroy();
    };
  }, [blob, onError]);

  return <div className="marked-tests-pages" ref={containerRef} role="img" aria-label={title} title={title} />;
}
